import { ACCENT_PRESETS } from '../../constants/templates';

export default function AccentPicker({
  effectiveAccent,
  effectiveAccent2,
  hasAccent2,
  hasOverride,
  setAccent,
  setAccent2,
  resetAccent,
}) {
  return (
    <div className="border-t border-stone-100 py-2.5 flex items-center gap-3 flex-wrap">
      <span className="tool-body text-[10px] uppercase tracking-[0.22em] text-stone-500 font-medium">Accent</span>

      <div className="flex items-center gap-1.5">
        <label className="relative w-7 h-7 rounded-full overflow-hidden border border-stone-300 cursor-pointer hover:border-stone-500 transition-colors" title="Pick a custom color">
          <input
            type="color"
            value={effectiveAccent}
            onChange={(e) => setAccent(e.target.value)}
            className="absolute inset-0 w-full h-full cursor-pointer opacity-0"
          />
          <span className="absolute inset-0 pointer-events-none" style={{ background: effectiveAccent }} />
        </label>
        <input
          type="text"
          value={effectiveAccent.toUpperCase()}
          onChange={(e) => {
            const v = e.target.value.trim();
            if (/^#?[0-9a-fA-F]{0,6}$/.test(v)) {
              setAccent(v.startsWith('#') ? v : '#' + v);
            }
          }}
          className="tool-body w-[5.5rem] px-2 py-1 text-[11px] font-mono uppercase border border-stone-300 rounded bg-white focus:outline-none focus:border-stone-600"
        />
      </div>

      <div className="hidden sm:flex items-center gap-1">
        {ACCENT_PRESETS.map(p => {
          const active = effectiveAccent.toLowerCase() === p.value.toLowerCase();
          return (
            <button
              key={p.value}
              onClick={() => setAccent(p.value)}
              className={`w-5 h-5 rounded-full border transition-transform hover:scale-110 ${
                active ? 'border-stone-900 ring-1 ring-stone-900 ring-offset-1' : 'border-stone-300'
              }`}
              style={{ background: p.value }}
              title={p.name}
              aria-label={p.name}
            />
          );
        })}
      </div>

      {hasAccent2 && (
        <>
          <span className="text-stone-300 hidden sm:inline">|</span>
          <span className="tool-body text-[10px] uppercase tracking-[0.22em] text-stone-500 font-medium">Underline</span>
          <label className="relative w-7 h-7 rounded-full overflow-hidden border border-stone-300 cursor-pointer hover:border-stone-500 transition-colors">
            <input
              type="color"
              value={effectiveAccent2 || '#C2511F'}
              onChange={(e) => setAccent2(e.target.value)}
              className="absolute inset-0 w-full h-full cursor-pointer opacity-0"
            />
            <span className="absolute inset-0 pointer-events-none" style={{ background: effectiveAccent2 || '#C2511F' }} />
          </label>
        </>
      )}

      {hasOverride && (
        <button
          onClick={resetAccent}
          className="tool-body ml-auto text-[11px] text-stone-600 hover:text-stone-900 underline underline-offset-2 decoration-stone-300 hover:decoration-stone-700 transition-colors"
        >
          Reset
        </button>
      )}
    </div>
  );
}
